import React, { Component } from 'react'
import Footer from '../../Component/Footer'
import Header from '../../Component/Header'
import Menu from '../../Component/Menu'
import ViewInvoice from './ViewInvoice'

export default class ViewInvoiceWrapper extends Component {
    render() {
        return (
            <div>
                <Header />
                 <Menu/>
                <>
              <div className="content-wrapper">
              <ViewInvoice/>

              </div>
              </>
              <Footer/>

            </div>
        )
    }
}
